var map = {
	"./Modl.ai/modl.ai_white.png": "33f3",
	"./accenture/Acc_Logo_White_Purple_RGB.png": "29a2",
	"./accenture/AccentureLogo.png": "7318",
	"./astralis/Astralis-red.png": "763e",
	"./astralis/Astralis-white.png": "6a9d",
	"./bybit/bybitlogo.png": "5f6f",
	"./capgemini/Capgemini_RGB.png": "d42c",
	"./capgemini/Capgemini_white.png": "a829",
	"./capgemini/capgemini.svg": "a325",
	"./epico/epico.svg": "259e",
	"./ida/IDA_Logo_2.png": "00a1",
	"./ida/IDA_white.png": "d22b",
	"./ida/IDA_white.svg": "07c7",
	"./ioi/IOI_Square_Black_White.png": "2dee",
	"./ioi/IOI_Square_White_Black.png": "9c30",
	"./ioi/IOI_white_large.png": "6a09",
	"./kmd/KMD_WHITE.png": "4c72",
	"./kmd/KMD_WHITE.svg": "9d65",
	"./milestone/milestone.svg": "6d94",
	"./milestone/milestone_png.png": "27e2",
	"./nordic_blockchain/Main_logo.png": "4b37",
	"./novo_nordisk/novo-nordisk-BW.png": "878f",
	"./novo_nordisk/novo-nordisk-innovationHub.png": "2237",
	"./novo_nordisk/novo-nordisk-innovationHub_BW.png": "094f",
	"./orsted/Orsted_RGB_White.png": "0ec9",
	"./sennheiser/sennheiser.svg": "7cd6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d790";